import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "className", "style"];
import React from 'react';
import { Card } from 'semantic-ui-react';
import { StylePropType } from '../../../../../../services/proptypes';
import { classNames } from '../../../../../../utils/classname';
import useSemanticUiProps from '../../../../../foundation/hooks/use-semantic-ui-props';
import { ChildrenPropType } from '../../../../../foundation/types/component';
import './Content.css';
var defaultProps = {
  className: '',
  style: {}
};
export default function Content(_ref) {
  var children = _ref.children,
    className = _ref.className,
    style = _ref.style,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useSemanticUiProps = useSemanticUiProps(),
    getCardContentProps = _useSemanticUiProps.getCardContentProps;
  var cardContentProps = getCardContentProps(rest);
  var finalClassName = classNames(_defineProperty({
    content: true
  }, className, !!className));
  return /*#__PURE__*/React.createElement(Card.Content, _extends({
    className: finalClassName,
    style: style
  }, cardContentProps), children);
}
Content.defaultProps = defaultProps;